import { Card } from '@mui/material';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;

  .MuiCardHeader-root {
    color: ${({ theme }) => theme.palette.primary.contrastText};
    background-color: ${({ theme }) => theme.palette.primary.main};

    &.disabled {
      background-color: ${({ theme }) => theme.palette.neutral.main};
    }
  }

  .MuiCardContent-root {
    align-items: center;
    text-align: center;
  }
`;
